import { emit, on } from "../../../core/state.js";

/**
 * End Quiz button + confirmation modal (parity with old #quiz-end-toggle).
 */
export default class QuizControls {
  render({ panelEl }) {
    this._panelEl = panelEl;

    const root = document.createElement("div");
    root.className = "ws-quiz-end-container";
    root.hidden = true;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.id = "ws-quiz-end-toggle";
    btn.textContent = "End Quiz";
    btn.addEventListener("click", () => this._openModal());
    root.appendChild(btn);

    const overlay = document.createElement("div");
    overlay.id = "ws-quiz-end-overlay";
    overlay.hidden = true;
    overlay.innerHTML = `
      <div class="ws-quiz-end-modal">
        <strong class="ws-quiz-end-modal-title">End Quiz?</strong>
        <div class="ws-quiz-end-modal-description">You haven't finished the quiz yet. Are you sure you want to exit now?</div>
        <div class="ws-quiz-end-action">
          <button type="button" class="ws-quiz-keep-going">No, Keep Going</button>
          <button type="button" class="ws-quiz-end-confirm">Yes, End Quiz</button>
        </div>
      </div>
    `;
    overlay.querySelector(".ws-quiz-keep-going").addEventListener("click", () => {
      overlay.hidden = true;
    });
    overlay.querySelector(".ws-quiz-end-confirm").addEventListener("click", () => {
      overlay.hidden = true;
      emit("ws-quiz-end-confirmed");
    });

    if (panelEl) {
      panelEl.appendChild(overlay);
    }

    on("ws-quiz-active", ({ active }) => {
      root.hidden = !active;
      if (!active) overlay.hidden = true;
    });

    return root;
  }

  _openModal() {
    const overlay = this._panelEl?.querySelector("#ws-quiz-end-overlay");
    if (overlay) overlay.hidden = false;
  }
}
